import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Grid.css";

export const ButtonFormatter = (handler: any, icon: any, isDisable: boolean, title: string) => (cell: any, row: any) => {
    return (
        <button title={title} disabled={isDisable &&!row.isDelete} onClick={() => handler(row, !row.isDelete)}>
            <FontAwesomeIcon icon={icon} className="buttonIcon"/>
        </button>
    );
}

export const EditFormatter = (handler: any, icon: any, isDisable: boolean, title: string) => (cell: any, row: any) => {
    return (
        <button title={title} disabled={isDisable && !row.isEdit} onClick={() => handler(row, !row.isEdit)}>
             <FontAwesomeIcon icon={icon} className="buttonIcon"/>
        </button>
    );
}

export const DownloadFormatter = (handler: any, isDisable: boolean, title: string) => (cell: any, row: any) => {
    return (
        <button title={title} disabled={isDisable &&!row.isDownload} onClick={() => handler(row)}>
            <svg width="18" height="18" fill={(isDisable &&!row.isDownload) ? "#747474" : "#000"} className="bi bi-download" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
        </button>
    );
}

export const ChangePasswordFormatter = (handler: any, icon: any, isDisable: boolean, title: string) => (cell: any, row: any) => {
    return (
        <button title={title} disabled={isDisable && !row.isChangePassword} onClick={() => handler(row, !row.isChangePassword)}>
             <FontAwesomeIcon icon={icon} className="buttonIcon"/>
        </button>
    );
}

